// @flow
export type DebouncedFunction<T: (...args: any[]) => any> = (
  ...args: Parameters<T>
) => void;

export type DebounceFunction = <T: (...args: any[]) => any>(
  func: T,
  wait: number,
  immediate?: boolean
) => DebouncedFunction<T>;

function debounce<T: (...args: any[]) => any>(
  func: T,
  wait: number,
  immediate?: boolean
): DebouncedFunction<T> {
  let timeout: any | null = null;
  return function debounced(
    this: ThisParameterType<T>,
    ...args: Parameters<T>
  ) {
    if (timeout) clearTimeout(timeout);
    if (immediate && !timeout) func.apply(this, args);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    }, wait);
  };
}
export default debounce;
